<template>
  <div class="mailto-link">
    <a :href="`mailto:${email}`">
      <FontIcon name="ui_contact" />
      <span class="text5">{{ text }}</span>
    </a>
  </div>
</template>

<style lang="scss">
.mailto {
  line-height: 22px;

  .contact-icon {
    font-size: 22px;
    height: 22px;
    display: block;
  }
}
</style>

<script>
import FontIcon from "../FontIcon";

export default {
  components: { FontIcon },

  props: {
    id: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
